import { ResultStream } from '@causality/core';
import { Campaign, FormMetadata } from '@formunauts/shared/campaigning/domain';
import {
  GetCampaignFormsMetadataError,
  GetSCOFormsMetadataError,
} from './form-meta-error.model';

export interface GetCampaignFormsMetadata {
  form_id: number;
  form_type: Campaign.FormType;
}

export abstract class FormMetadataRepository {
  abstract getCampaignFormsMetadata(
    form_id: number,
    form_type: Campaign.FormType,
  ): ResultStream.ResultStream<FormMetadata, GetCampaignFormsMetadataError>;
  abstract getSCOFormsMetadata(
    hash: string,
  ): ResultStream.ResultStream<FormMetadata, GetSCOFormsMetadataError>;
}
